module.exports = __webpack_public_path__ + "static/media/smartphone.07c28484.png";